/**
 * Error de dominio del cobro QR. TypeScript puro.
 *
 * Contrato del port: TODA implementación de `PaymentQrRepository` falla con
 * esta clase, así que el consumidor nunca ve un `HttpErrorResponse` ni un
 * cuerpo del backend. Lleva SOLO datos para clasificar — tipo, status HTTP,
 * `error_code` y nombres de campo —, nunca el `detail`/`message` del backend
 * (CLAUDE.md §Security: ese texto no se muestra ni se registra).
 */
export type PaymentQrErrorKind =
  | 'disabled'
  | 'requires-account'
  | 'not-configured'
  | 'validation'
  | 'conflict'
  | 'coded'
  | 'forbidden'
  | 'not-found'
  | 'network'
  /**
   * 401: la credencial no vale. La renovación es del flujo global de sesión, no de
   * la pantalla; el sondeo del QR se detiene en vez de contarlo como una falla más.
   */
  | 'session'
  | 'unknown';

export class PaymentQrError extends Error {
  constructor(
    readonly kind: PaymentQrErrorKind,
    readonly status: number,
    /** `error_code` tal cual; solo para clasificar (`errors.codes.<CODE>`). */
    readonly code: string | null = null,
    /** SOLO nombres de campo del 400 de validación, nunca sus mensajes. */
    readonly fields: readonly string[] = [],
  ) {
    super(`PaymentQrError:${kind}`);
    this.name = 'PaymentQrError';
  }
}

export function isPaymentQrError(value: unknown): value is PaymentQrError {
  return value instanceof PaymentQrError;
}
